<div mat-dialog-content>
   <iframe #emailIframe></iframe>
</div>

<div mat-dialog-actions style="justify-content: right">
   <button mat-raised-button color="primary" style="min-width: unset" (click)="dismiss($event)"
      >{{"emaillog.close" | translate}}</button
   >
</div>
